import { useState } from "react";
import { FaMinus } from "react-icons/fa6";
import { FaCheck } from "react-icons/fa6";
import CalvinLogo from "../../../assets/Images/Calvin-Group-Logo.svg";
import RightIcon from "../../../assets/Images/rightIcon.svg";
import MachineImg from "../../../assets/Images/machineImg.svg";
import { useLocation, useNavigate } from "react-router-dom";
import { currencyFormat, detailPageURL, detailSideBarPageURL, logoutFun } from "../../../utils/helper";
import NoImgIcon from "../../../assets/png/no-image-icon.png";
import Icon from "../../icon/Icon";
import { addWatchList } from "../../../services/vizyBilityServices";
import { toast } from "react-toastify";
import { useMsal } from "@azure/msal-react";
import { DeleteIcon } from "../../../assets/images";
import RemoveWatchListConfirmationModel from "../../../page/admin/watchList/model/removeWatchListConfirmation";

const SidebarWatchListCard = ({ data, handelReload }) => {
  const { instance, accounts } = useMsal();
  const [cardLoading, setCardLoading] = useState(false);
  const [modalStatus, setModalStatus] = useState(false);
  const Logout = localStorage.getItem("getAzureUserData") || localStorage.getItem("azuretoken");
  const azureUserInfo = localStorage.getItem("getAzureUserData")
    ? JSON.parse(localStorage.getItem("getAzureUserData") || {})
    : null;
  const [watchList, setWatchList] = useState(true);
  const { state } = useLocation();
  const navigate = useNavigate();
  // State for the custom checkbox
  const [checkboxState, setCheckboxState] = useState("not-selected");

  // Handle checkbox click to cycle through states
  const handleCheckboxClick = () => {
    setCheckboxState((prevState) => {
      if (prevState === "not-selected") return "selected";
      if (prevState === "selected") return "minus";
      return "not-selected";
    });
  };
  const Rpath = detailSideBarPageURL(data);

  const handelWatchList = () => {
    setCardLoading(true);
    let payload = {
      assetId: data?.id || data?.AssetId,
      assetAdvertisementId: data?.assetAdvertisementId,
      contactId: azureUserInfo?.ContactId,
    };
    if (watchList) {
      payload = {
        ...payload,
        active: false,
      };
    } else {
      payload = {
        ...payload,
        active: true,
      };
    }

    const header = {
      authorization: `Bearer ${localStorage.getItem("vizy-bility-token")}`,
    };

    addWatchList(payload, header, instance, accounts)
      .then((res) => {
        setCardLoading(false);
        setWatchList(!watchList);
        if (watchList) {
          toast.success("Successfully removed from watchlist!");
        } else {
          toast.success("Successfully added to watchlist!");
        }

        handelReload();
      })
      .catch((err) => {
        setCardLoading(false);
        if (err?.status == 401 || err?.statusText == "Unauthorized") {
          toast.error("you are logged out, login again to add machines to watchlist.");
          logoutFun(instance);
        } else {
          toast.error(err?.data);
        }
      });
  };

  const handleOnPressCall = () => {
    if (data?.ContactPhone) {
      return `callto:${data?.ContactPhone}`;
    } else if (data?.ContactEmail) {
      return `mailto:${data?.ContactEmail}`;
    } else {
      return "javascript:void(0)";
    }
  };

  return (
    <>
      <div className="shadow-xl relative group grid grid-cols-3">
        <div
          onClick={() => {
            navigate(Rpath, { state: { ...state, assetAdvertisementId: data?.assetAdvertisementId || data?.AssetAdvertisementId } });
            window.location.reload();
          }}
          className="cursor-pointer col-span-1"
        >
          <img
            src={data?.PrimaryImage.url || NoImgIcon}
            alt="Machine"
            className="object-cover rounded-lg w-full h-[150px]"
          />
        </div>
        <div className="col-span-2 flex flex-col justify-between">
          <div className="p-[10px]">
            <div
              className="text-[#fff] text-[20px] font-bold cursor-pointer  break-words"
              onClick={() => {
                navigate(Rpath, { state: { ...state, assetAdvertisementId: data?.assetAdvertisementId || data?.AssetAdvertisementId } });
                window.location.reload();
              }}
            >
              {data?.Year}&nbsp;
              {data?.MakeName}&nbsp;
              {data?.Model}
            </div>
            {data?.CompanyName && <div className="text-[#fff] text-[16px] font-medium">{data?.CompanyName}</div>}
            {data?.LastKnownSMU && (
              <div className="text-[#fff] text-[14px] font-medium">
                {data?.LastKnownSMU} {data?.SMUUnits ? data?.SMUUnits : "Hours"}
              </div>
            )}
          </div>
          <div className="flex justify-between items-center mt-4 top-[-10px] left-1 opacity-100 pl-[10px]">
            {data?.AdvertisedPrice == 0.0 && data?.AdvertisedPrice == 0 ? (
              <a
                href={handleOnPressCall()}
                className="bg-[#FEBA06] py-[4px] text-[#161412] text-[14px] px-2 rounded disable:hover  "
              >
                Call for Pricing
              </a>
            ) : (
              <div className="text-[#fff] text-[14px] font-medium">
                {data?.AdvertisedCurrency
                  ? data?.AdvertisedCurrency === "USD" || data?.AdvertisedCurrency === "CAD"
                    ? "$"
                    : null
                  : null}
                {currencyFormat(Number(data?.AdvertisedPrice))}
              </div>
            )}
            <button
              onClick={() => setModalStatus(true)}
              className="mr-[5px] mb-[10px] bg-[#feba06] text-[#fff] p-3 rounded-full"
              disabled={cardLoading}
            >
              {/* {cardLoading ? "loading..." : "Remove WatchList"} */}

              <img src={DeleteIcon} alt="" className="w-[20px]" />
            </button>
            {/* )} */}
          </div>
        </div>
      </div>

      <RemoveWatchListConfirmationModel
        modalStatus={modalStatus}
        setModalStatus={setModalStatus}
        handleRemoveWatchList={handelWatchList}
        isLoading={cardLoading}
      />
    </>
  );
};

export default SidebarWatchListCard;
